import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NbDialogService, NbGlobalPhysicalPosition, NbToastrService } from '@nebular/theme';
import { ConfirmOperationComponent } from '../../../@theme/components/confirm-operation/confirm-operation.component';
import { ColumnRenderStatusComponent } from '../result-import/column-render-status.component';
import { CustomMenuComponent } from './custom-action-menu.component';
import { MyCustomComponent } from './custom-action.component';
import { InternalSearchService } from './internal-search.service';


@Component({
  selector: 'ngx-internal-search',
  templateUrl: './internal-search.component.html',
  styleUrls: ['./internal-search.component.scss'],
})
export class InternalSearchComponent {

  public researches = [];
  public researchesTodo = [];
  public researchesFinish = [];

  settings = {
    actions: {
      columnTitle: 'Ações',
    },
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      createButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
    },
    mode: 'external',
    columns: {
      name: {
        title: 'Nome',
        type: 'string',
      },
      description: {
        title: 'Descrição',
        type: 'string',
      },
      status: {
        title: 'Status',
        type: 'custom',
        renderComponent: ColumnRenderStatusComponent,
        filter: false,
        editable: false,
        width: '8%',
      },
      customColumn: {
        title: '',
        type: 'custom',
        width: '8%',
        filter: false,
        renderComponent: MyCustomComponent,
        onComponentInitFunction: (instance) => {
          instance.save.subscribe(row => {
            switch (row.context) {
              case 'DASHBOARD':
                this.router.navigate(['pages/internal-search/dashboard', row.id]);
                break;
              default:
                break;
            }

          });
        },
      },
      customColumnMenu: {
        title: '',
        type: 'custom',
        width: '10%',
        filter: false,
        renderComponent: CustomMenuComponent,
        onComponentInitFunction: (instance) => {
          instance.save.subscribe(row => {
            switch (row.context) {
              case 'CLONE':
                this.clone(row.id);
                break;
              case 'CLEAN':
                this.onCleanConfirm(row);
                break;
              case 'NOTIFY':
                this.onNotifyConfirm(row);
                break;

              default:
                break;
            }
          });
        },
      },
    },
    noDataMessage: 'Nenhum registro encontrado',
  };

  constructor(private internalSearchServive: InternalSearchService, private router: Router,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService) {
    this.getAll();
  }

  getAll() {
    this.internalSearchServive.query({status: 'WAITING_FOR'}).toPromise().then(response => {
      this.researches = response.body;
    });

    this.internalSearchServive.query({status: 'RUNNING'}).toPromise().then(response => {
      this.researchesTodo = response.body;
    });

    this.internalSearchServive.query({status: 'FINISH'}).toPromise().then(response => {
      this.researchesFinish = response.body;
    });
  }

  openCreateDialog() {
    this.router.navigate(['pages/admin/internal-search', 'create']);
  }

  openEditDialog(event): void {
    this.router.navigate(['pages/admin/internal-search', event.data.id]);
  }



  onNotifyConfirm(event): void {
    this.dialogService.open(ConfirmOperationComponent, {
      closeOnBackdropClick: false,
      context: {
        title: 'Notificar usuários',
        text: `Você realmente deseja notificar todos os usuários que ainda não responderam a pesquisa ${event.name}?`,
        accent: 'danger',
      },
    }).onClose.subscribe(response => response.confirmed && this.notify(event.id));
  }

  notify(id) {
    this.internalSearchServive.notify(id).toPromise().then(result => {
      this.toastrService.show('Pesquisa', 'Notificação enviada com sucesso!',
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
    });
  }

  onCleanConfirm(event): void {
    this.dialogService.open(ConfirmOperationComponent, {
      closeOnBackdropClick: false,
      context: {
        title: 'Limpar pesquisa',
        text: `Você realmente deseja limpar todas as respostas da pesquisa ${event.name}?`,
        accent: 'danger',
      },
    }).onClose.subscribe(response => response.confirmed && this.clean(event.id));
  }

  clean(id) {
    this.internalSearchServive.removeAllAnswers(id).toPromise().then(result => {
      this.toastrService.show('Pesquisa', 'Respostas excluidas com sucesso',
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
    })
  }

  clone(id) {
    this.internalSearchServive.clone(id).toPromise().then(result => {
      this.getAll();
      this.toastrService.show('Pesquisa', 'Clonada com sucesso!',
      { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
      setTimeout(() => {
        this.router.navigate(['pages/admin/internal-search', result.body.id]);
      }, 500);
    }).catch(err => {
      this.toastrService.show('Pesquisa', 'Erro ao clonar a pesquisa.',
      { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'danger' });
    });
  }

  onDeleteConfirm(event): void {
    this.dialogService.open(ConfirmOperationComponent, {
      closeOnBackdropClick: false,
      context: {
        title: 'Excluir pesquisa',
        text: `Você realmente deseja excluir a pesquisa ${event.data.name}?`,
        accent: 'danger',
        force: true,
        LabelForce: 'Excluir respostas'
      },
    }).onClose.subscribe(response => response.confirmed && this.delete(event.data.id, response.force));
  }

  delete(id, force) {
    this.internalSearchServive.delete(id, force).toPromise().then(response => {
      this.toastrService.show('Pesquisa', 'Excluído com sucesso',
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
      this.getAll();
    }).catch(err => {
      this.toastrService.show('Pesquisa', err.error.title,
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'danger' });
    });
  }


}
